export default __webpack_public_path__ + "static/media/loaderIcon.c8cece83.gif";